import { Checkbox, Selection, DetailsHeader, DetailsList, DetailsListLayoutMode, DetailsRow, ICheckboxStyles, IColumn, Icon, IDetailsColumnProps, IDetailsColumnStyles, IDetailsHeaderProps, IDetailsHeaderStyles, IDetailsRowProps, IRenderFunction, Link, ProgressIndicator, SelectionMode, Stack, TooltipHost, useTheme } from '@fluentui/react';
import * as React from 'react';
import { EventPriceTypeEnum } from '../../../../../Models/Event/EventPriceTypeEnum';
import { IAttendeeRegistrationListItem, IAttendeeRegistrationListItemSelected } from '../../../../../Models/Event/IAttendeeRegistrationListItem';
import { IUserProfile } from '../../../../../Models/Profile/IUserProfile';

interface IAttendeeRegistrationGridListProps {
    isLoading: boolean;
    items: IAttendeeRegistrationListItemSelected[];
    openDetail?: (item: IAttendeeRegistrationListItemSelected) => void;
    setSelected?: (item: IAttendeeRegistrationListItemSelected[]) => void;
    invoiceSelection?: (registrationId: number, fieldName: string, value: boolean) => void;
    invoiceAllSelection?: (selectFa: keyof IAttendeeRegistrationListItemSelected, fieldName: string, value: boolean) => void
    selectionMode: SelectionMode;
    profile: IUserProfile;
}


export const AttendeeRegistrationGridList: React.FunctionComponent<IAttendeeRegistrationGridListProps> = (props) => {
    const [columns, setColumns] = React.useState<IColumn[]>([]);
    const [selected, setSelected] = React.useState<IAttendeeRegistrationListItemSelected[]>([]);

    const [selectionState] = React.useState(new Selection({
        onSelectionChanged: () => {
            const selected = selectionState.getSelection() as IAttendeeRegistrationListItemSelected[];
            setSelected(selected);
        },
        selectionMode: props.selectionMode
    }));

    const theme = useTheme();

    const checkBoxStyle: Partial<ICheckboxStyles> = {
        root: {

        },
        label: {
            color: theme.palette.black, fontWeight: 400, fontSize: theme.fonts.small.fontSize,

        },
        text: { color: theme.palette.black, fontWeight: 400, fontSize: theme.fonts.small.fontSize, }
    }

    const headerStyle: Partial<IDetailsColumnStyles> = {
        cellName: {
            fontFamily: "Comfortaa, serif",
            color: theme.palette.blue,
        },
    }

    React.useEffect(() => {
        buildColumns(props.items);        
    }, [props.items])

    React.useEffect(() => {
        if (selected.length > 0) {
            props.setSelected && props.setSelected(selected);
        }
    }, [selected])

    const selectAllChange = (ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) => {
        if (ev?.currentTarget.id) {
            const canField = ev?.currentTarget.getAttribute("data-canField") as keyof IAttendeeRegistrationListItemSelected;
            const changeField = ev?.currentTarget.getAttribute("data-changeField");
            if (changeField && canField) {
                props.invoiceAllSelection && props.invoiceAllSelection(canField, changeField, checked === true);
            }
            return true;
        }
    }

    const renderHeaderPrice = (props: IDetailsColumnProps | undefined, defaultrender: IRenderFunction<IDetailsColumnProps> | undefined, canField: string, changeField: string) => {
        if (props) {
            const att =
                {
                    'data-canField': canField,
                    "data-changeField": changeField
                } as any;

            return <span>
                <Stack verticalFill verticalAlign="end" styles={{ root: { paddingTop: 11 } }}>
                    <Checkbox
                        inputProps={att}
                        onChange={selectAllChange} label={props.column.name} />
                </Stack>
            </span>
        }
        return null;
    }

    const buildColumns = (items: IAttendeeRegistrationListItem[]) => {
        const _columns: IColumn[] = [
            { key: 'firstName', isCollapsible: true, name: 'Jméno', fieldName: 'firstName', minWidth: 100, maxWidth: 200, isResizable: true, styles: headerStyle },
            { key: 'lastName', name: 'Příjmení', fieldName: 'lastName', minWidth: 100, maxWidth: 400, isResizable: true, styles: headerStyle },
            { key: 'isSubstitute', name: 'Náhradník', fieldName: 'isSubstitute', minWidth: 80, maxWidth: 100, isResizable: true, styles: headerStyle },
        ];

        if (items && items.length > 0) {
            const item = items[0];
            if (item.priceType === EventPriceTypeEnum.ByEvent && (props.profile.isAccountant || props.profile.isAdmin)) {
                _columns.push({
                    key: 'price',
                    onRenderHeader: (props, render) => { return renderHeaderPrice(props, render, "canCreatePriceInvoice", "priceInvoiceSelected") },
                    name: 'Cena', fieldName: 'price', minWidth: 100, maxWidth: 150, isResizable: true, styles: headerStyle
                });
            }
            if (item.priceType === EventPriceTypeEnum.BySemester && (props.profile.isAccountant || props.profile.isAdmin)) {

                _columns.push({
                    key: 'firstSemesterPrice',
                    onRenderHeader: (props, render) => { return renderHeaderPrice(props, render, "canCreateFirstPriceInvoice", "priceFirstSemesterInvoiceSelected") },
                    name: '1.pol', fieldName: 'firstSemesterPrice', minWidth: 80, maxWidth: 80, isResizable: false, styles: headerStyle
                });
                _columns.push({
                    key: 'secondSemesterPrice',
                    onRenderHeader: (props, render) => { return renderHeaderPrice(props, render, "canCreateSecondPriceInvoice", "priceSecondSemesterInvoiceSelected") },
                    name: '2.pol', fieldName: 'secondSemesterPrice', minWidth: 80, maxWidth: 80, isResizable: false, styles: headerStyle
                });
            }

        }
        setColumns(_columns);
    }

    const renderInvoice = (invoces?: string) => {
        if (invoces && invoces != "") {
            const items = invoces.split(",").filter((v, i, a) => a.indexOf(v) === i);
            return <Stack horizontal tokens={{ childrenGap: 2 }}>
                {items.map((item, index, a) => {
                    return <Link>{item + (index < a.length - 1 ? "," : "")}</Link>
                })}
            </Stack>
        }
        return null
    }

    const invoiceSlectionChanged = (ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) => {
        if (ev?.currentTarget.id) {
            const canField = ev?.currentTarget.getAttribute("data-fieldName") as keyof IAttendeeRegistrationListItemSelected;
            const registrationId: number = Number.parseInt(ev?.currentTarget.id.substring(1));
            props.invoiceSelection && props.invoiceSelection(registrationId, canField, checked === true);
        }
        ev?.stopPropagation();

    }

    const renderPaymentIcon = (total: number, paid: number, overdue: boolean) => {

        return (total > paid ?
            overdue ?
                <Icon iconName="Cancel" title="Nezapalaceno po splatnosti" styles={{ root: { color: theme.semanticColors.errorIcon, fontWeight: 400, fontSize: theme.fonts.medium.fontSize } }} />
                : null
            :
            (total != 0 && paid != 0 && total <= paid) ?
                <Icon iconName="CheckMark" title="Zaplaceno" styles={{ root: { color: theme.semanticColors.successIcon, fontWeight: 400, fontSize: theme.fonts.medium.fontSize } }} />
                : null)
    }

    const renderPrice = (item: IAttendeeRegistrationListItemSelected) => {
        const inputProps = { 'data-fieldName': "priceInvoiceSelected" } as any;
        return (<span style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
            {item.canCreatePriceInvoice ?
                <TooltipHost
                    content={
                        <div>
                            <div>
                                <b>Vytvořit fakturu</b>
                            </div>
                            {
                                (item.priceInvoices ?
                                    <div>
                                        <div>{"Již fakturováno: " + item.priceInvoiceTotal}</div>
                                        <div>Faktury: {renderInvoice(item.priceInvoices)}</div>
                                    </div>
                                    : "")
                            }
                        </div>}
                >
                    <span style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
                        <Checkbox key={"event" + item.id.toString()}
                            id={"e" + item.id.toString()}
                            checked={item.priceInvoiceSelected}
                            inputProps={inputProps}
                            onChange={invoiceSlectionChanged} styles={checkBoxStyle}
                            title="Vytvořit fakturu" label={(item.price - (item.priceInvoiceTotal ? item.priceInvoiceTotal : 0)).toString()} />
                         {
                          renderPaymentIcon(item.priceInvoiceTotal ? item.priceInvoiceTotal : 0, item.priceInvoicePaidTotal ? item.priceInvoicePaidTotal : 0, item.priceInvoiceIsOverdue ? item.priceInvoiceIsOverdue:false)
                         }
                    </span>
                </TooltipHost>
                : <span style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
                    {renderInvoice(item.priceInvoices)}
                    {
                        renderPaymentIcon(item.priceInvoiceTotal ? item.priceInvoiceTotal : 0, item.priceInvoicePaidTotal ? item.priceInvoicePaidTotal : 0, item.priceInvoiceIsOverdue ? item.priceInvoiceIsOverdue : false)
                    }
                </span>
            }
        </span>
        )
    }

    const renderFirstSemesterPrice = (item: IAttendeeRegistrationListItemSelected) => {
        const inputProps = { 'data-fieldName': "priceFirstSemesterInvoiceSelected" } as any;

        return (
            <span style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
                {item.canCreateFirstPriceInvoice ?
                    <TooltipHost
                        content={
                            <div>
                                <div>
                                    <b>Vytvořit fakturu</b>
                                </div>
                                {
                                    (item.firstSemesterPrice ?
                                        <div>
                                            <div>{"Již fakturováno: " + item.firstSemesterPriceInvoiceTotal}</div>
                                            <div>Faktury: {renderInvoice(item.firstSemesterPriceInvoices)}</div>
                                        </div>
                                        : "")
                                }
                            </div>}>
                        <span style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
                            <Checkbox key={"first" + item.id.toString()}
                                id={"f" + item.id.toString()}
                                checked={item.priceFirstSemesterInvoiceSelected}
                                inputProps={inputProps}
                                onChange={invoiceSlectionChanged} styles={checkBoxStyle}
                                title="Vytvořit fakturu" label={(item.firstSemesterPrice - (item.firstSemesterPriceInvoiceTotal ? item.firstSemesterPriceInvoiceTotal : 0)).toString()} />
                            {
                                renderPaymentIcon(item.firstSemesterPriceInvoiceTotal ? item.firstSemesterPriceInvoiceTotal : 0, item.firstSemesterPriceInvoicePaidTotal ? item.firstSemesterPriceInvoicePaidTotal : 0, item.firstSemesterPriceInvoiceIsOverdue ? item.firstSemesterPriceInvoiceIsOverdue : false)
                            }

                        </span>
                    </TooltipHost>
                    : <span style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
                        {renderInvoice(item.firstSemesterPriceInvoices)}
                        {
                            renderPaymentIcon(item.firstSemesterPriceInvoiceTotal ? item.firstSemesterPriceInvoiceTotal : 0, item.firstSemesterPriceInvoicePaidTotal ? item.firstSemesterPriceInvoicePaidTotal : 0, item.firstSemesterPriceInvoiceIsOverdue ? item.firstSemesterPriceInvoiceIsOverdue : false)
                        }
                    </span>
                }
            </span>
        )
    }

    const renderSecondSemesterPrice = (item: IAttendeeRegistrationListItemSelected) => {
        const inputProps = { 'data-fieldName': "priceSecondSemesterInvoiceSelected" } as any;

        return (
            <span style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
                {item.canCreateSecondPriceInvoice ?

                    <span style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
                        <Checkbox
                            key={"second" + item.id.toString()}
                            id={"s" + item.id.toString()}
                            checked={item.priceSecondSemesterInvoiceSelected}
                            onChange={invoiceSlectionChanged}
                            styles={checkBoxStyle}
                            inputProps={inputProps}
                            title="Vytvořit fakturu" label={(item.secondSemesterPrice - (item.secondSemesterPriceInvoiceTotal ? item.secondSemesterPriceInvoiceTotal : 0)).toString()} />
                        {
                            renderPaymentIcon(item.secondSemesterPriceInvoiceTotal ? item.secondSemesterPriceInvoiceTotal : 0, item.secondSemesterPriceInvoicePaidTotal ? item.secondSemesterPriceInvoicePaidTotal : 0, item.secondSemesterPriceInvoiceIsOverdue ? item.secondSemesterPriceInvoiceIsOverdue : false)
                        }

                    </span>
                    : <span style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
                        {renderInvoice(item.secondSemesterPriceInvoices)}
                        {
                            renderPaymentIcon(item.secondSemesterPriceInvoiceTotal ? item.secondSemesterPriceInvoiceTotal : 0, item.secondSemesterPriceInvoicePaidTotal ? item.secondSemesterPriceInvoicePaidTotal : 0, item.secondSemesterPriceInvoiceIsOverdue ? item.secondSemesterPriceInvoiceIsOverdue : false)
                        }
                    </span>
                }
            </span>
        )
    }

    const renderItemColumn = (item: IAttendeeRegistrationListItemSelected, index?: number, column?: IColumn) => {
        if (index != undefined && column != undefined) {
            const fieldContent = item[column.fieldName as keyof IAttendeeRegistrationListItemSelected];
            switch (column.key) {
                case "firstName":
                    return <span style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
                        <Link onClick={() => { props.openDetail && props.openDetail(item) }}>{fieldContent}</Link>
                    </span>
                case "price":
                    return <span style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
                        {renderPrice(item)}
                    </span>
                case "firstSemesterPrice":
                    return <span style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
                        {item.priceType === EventPriceTypeEnum.BySemester ? renderFirstSemesterPrice(item) : renderPrice(item)}
                    </span>
                case "secondSemesterPrice":
                    return <span style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
                        {renderSecondSemesterPrice(item)}
                    </span>
                case 'isSubstitute':
                    return <div><Icon styles={{ root: { fontSize: 16 } }} iconName={item.isSubstitute ? "UserOptional" : "UserFollowed"} title={item.isSubstitute ? "Náhradník" : "Přihlášený uživatel"} /></div>;
                default:
                    return <span style={{ height: '100%', display: 'flex', alignItems: 'center' }}>{fieldContent}</span>;
            }
        }
        else {
            return (<div></div>)
        }
    }

    const headerRowStyle: Partial<IDetailsHeaderStyles> = {
        root: {
            borderColor: theme.palette.blue,
            borderBottomWidth: 2
        }
    }

    const onRenderDetailsHeader: IRenderFunction<IDetailsHeaderProps> = (props, defaultRender) => {
        if (props) {
            props = { ...props, styles: headerRowStyle };
            return (
                <DetailsHeader
                    {...props}
                />
            );
        }
        return null;
    }
    const onRenderRow: IRenderFunction<IDetailsRowProps> = (props: any, defaultRender: any) => {
        return (<div key={props.item.key} data-selection-toggle="false" data-selection-touch-invoke="false" data-selection-disabled={true}>
            <DetailsRow {...props} onClick={(ev?: any) => {
                if (ev.target.classList.contains('ms-Check-check')) {

                    selectionState.setKeySelected(props?.item.key, !selectionState.isKeySelected(props?.item.key), false);
                }
            }} />
        </div>)
    }


    return (
        <Stack><Stack styles={{ root: { height: 10 } }}>
            {props.isLoading ? <ProgressIndicator /> : null}
        </Stack>
            <DetailsList
                items={props.items}
                columns={columns}
                setKey="set"
                onRenderDetailsHeader={onRenderDetailsHeader}
                selectionMode={props.selectionMode}
                layoutMode={DetailsListLayoutMode.justified}
                onRenderItemColumn={renderItemColumn}
                selection={selectionState}
                selectionPreservedOnEmptyClick={false}
                ariaLabelForSelectionColumn="Výběr věkové skupiny"
                ariaLabelForSelectAllCheckbox="Výběr věkové skupiny"
                checkButtonAriaLabel="Vyber řádek"
                onRenderRow={onRenderRow}
                onItemInvoked={props.openDetail} />
        </Stack>)
    }

